import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, PrinterIcon, PlaneIcon } from 'lucide-react';
const steps = [{
  icon: <DownloadIcon className="w-8 h-8" data-id="element-63" />,
  title: 'DOWNLOAD',
  desc: 'Get instant access to the guide and all printable templates immediately after purchase.'
}, {
  icon: <PrinterIcon className="w-8 h-8" data-id="element-64" />,
  title: 'PRINT & PACK',
  desc: 'Use the SOS list to pack your bag and print the activity bundle at home.'
}, {
  icon: <PlaneIcon className="w-8 h-8" data-id="element-65" />,
  title: 'DEPLOY',
  desc: 'Follow the 20/20 Rotation Rule during your trip and enjoy the rarest sound in travel: silence.'
}];
export function HowItWorksSection() {
  return <section className="py-10 md:py-16 bg-white" data-id="element-66">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67">
        <div className="text-center mb-10" data-id="element-68">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-3" data-id="element-69">
            How It Works
          </h2>
          <p className="text-lg text-gray-600" data-id="element-70">
            Three simple steps to a stress-free journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative" data-id="element-71">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-0.5 bg-brand-blue/20 z-0" data-id="element-72"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-73">
              <div className="w-16 h-16 bg-brand-cream rounded-full flex items-center justify-center border-4 border-white shadow-md mb-4 text-brand-blue" data-id="element-74">
                {step.icon}
              </div>
              <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 w-full h-full" data-id="element-75">
                <div className="text-sm font-bold text-brand-orange mb-1" data-id="element-76">
                  STEP {index + 1}
                </div>
                <h3 className="text-lg font-bold text-brand-dark mb-2" data-id="element-77">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-78">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}